<template>
  <div class="onlineBankingCCB-container" v-loading="loading">
    <component :is="views" @gotoPage="gotoPage" />
  </div>
</template>

<script setup name="OnlineBankingCCBManager">
import { cloneDeep } from "lodash";
import { ElMessage, ElMessageBox } from "element-plus";
import { $emit, $on } from "vue-happy-bus";
import { useOnlineBankingCCBStore } from "@/store/modules/onlineBankingCCB.js";
const { solutionUpdate, solutionReset } = useOnlineBankingCCBStore();
import index from "./pages/index.vue";

const getGrandchildValue = inject("getGrandchildValue");

const props = defineProps({
  currentQa: {
    // 当前题目信息对象
    required: true,
    type: Object,
  },
});

const route = useRoute();
const router = useRouter();
const isDev = ref(import.meta.env.DEV);
const { proxy } = getCurrentInstance();
const { id } = route.query;

const loading = ref(false);
const init = async () => {
  loading.value = true;
  const currentQa = toRaw(props.currentQa);

  try {
    let solution = currentQa.solution && JSON.parse(currentQa.solution);

    if (!solution) {
      solution = {
        que1: {
          passwordCashierShield: '', // 出纳-U盾密码
          passwordCashierLogin: '', // 出纳-登录密码
        }
      };
    }

    solutionUpdate(solution);

    provide("currentQa", currentQa);

    console.log("获取数据", { solution, currentQa });
  } finally {
    loading.value = false;
  }
};

// 页面
const pages = {
  index,
};

const gotoPage = (page) => {
  views.value = pages[page];
};

const views = shallowRef();

gotoPage("index");

$on("gotoPage", (page) => {
  gotoPage(page);
});

// 重新做题
getGrandchildValue.value.getResetData = () => {
  inspectionReset();

  return {
    solution: "",
  };
};

// 提交
$on("inspectionSubmit", (solution) => {
  console.log("提交数据", solution);

  getGrandchildValue.value.getData = () => {
    return {
      solution: JSON.stringify(solution),
    };
  };

  getGrandchildValue.value.fillFinish = () => {
    return true;
  };

  solutionUpdate(solution);

  $emit("exeSaveQa");
});

// 保存成功回调
$on("saveQaSuccess", (res) => {
  ElMessage.success("提交成功");
});

onMounted(() => {
  $('.onlineBankingCCB-container').on('click', 'a', function() {
    return false;
  });

  init();
});
</script>

<style scoped lang="scss">
.onlineBankingCCB-container {
  width: 100%;
  height: 100%;
  font-size: 14px;
  line-height: 1.5;
  overflow-y: auto;
}
</style>
